import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import * as styles from './PlanTableRow.scss';

var SubscribedPostPlanTableRow = /*#__PURE__*/function (_Component) {
  _inherits(SubscribedPostPlanTableRow, _Component);

  var _super = _createSuper(SubscribedPostPlanTableRow);

  function SubscribedPostPlanTableRow(props) {
    var _this;

    _classCallCheck(this, SubscribedPostPlanTableRow);

    _this = _super.call(this, props);
    _this.state = {
      editMode: false,
      editNumPosts: '',
      editBudget: ''
    };
    return _this;
  }

  _createClass(SubscribedPostPlanTableRow, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          ad = _this$props.ad,
          editable = _this$props.editable;
      console.log('SubscribedPostPlanTableRow');
      return /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, editable && /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.btnWrap, " ").concat(styles.iconWrap)
      }, !this.state.editMode && /*#__PURE__*/React.createElement("span", {
        className: styles.iconPlaceholder
      }), this.state.editMode ? /*#__PURE__*/React.createElement(RaisedButton, {
        disabled: this.state.savingBudget,
        label: "Save",
        onClick: function onClick() {
          if (!isNaN(parseFloat(_this2.state.editBudget))) {
            _this2.setState({
              savingBudget: true
            });

            _this2.props.handleEditPlanItem(parseInt(_this2.state.editNumPosts), parseInt(_this2.state.editBudget));

            _this2.setState({
              editMode: false,
              editNumPosts: '',
              editBudget: '',
              savingBudget: false
            });
          }
        }
      }) : /*#__PURE__*/React.createElement("i", {
        className: "".concat(styles.icon, " icon ion-edit"),
        onClick: function onClick() {
          return _this2.setState({
            editMode: true,
            editNumPosts: ad.numPosts,
            editBudget: ad.budget / 100.0
          });
        }
      }), this.state.savingBudget && /*#__PURE__*/React.createElement("i", {
        style: {
          marginLeft: 12
        },
        className: "fa fa-circle-o-notch fa-spin"
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.textWrap
      }, this.state.editMode ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", null, "Posts To Boost:"), ' ', /*#__PURE__*/React.createElement(TextField, {
        style: {
          marginRight: 40,
          width: 75
        },
        value: this.state.editNumPosts,
        onChange: function onChange(e) {
          _this2.setState({
            editNumPosts: e.target.value
          });
        }
      })) : /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles.textCol, " ").concat(styles.col2),
        style: {
          flex: '0 0 290px'
        }
      }, "Posts To Boost: ", ad.numPosts), this.state.editMode ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", null, "Per Post: $"), /*#__PURE__*/React.createElement(TextField, {
        style: {
          width: 75
        },
        value: this.state.editBudget,
        onChange: function onChange(e) {
          _this2.setState({
            editBudget: e.target.value
          });
        }
      })) : /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles.textCol, " ").concat(styles.col3)
      }, "Per Post: ", this.props.formatCurrency(ad.budget)), /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles.textCol, " ").concat(styles.col4)
      }, this.state.editMode || ad.newAd ? '' : ad.result)), !this.state.editMode && /*#__PURE__*/React.createElement("div", {
        className: styles.trashWrap
      }, /*#__PURE__*/React.createElement("i", {
        className: "".concat(styles.icon, " icon ion-ios-trash-outline"),
        onClick: function onClick() {
          return _this2.props.handleDeletePlanItem(ad.id);
        }
      })));
    }
  }]);

  return SubscribedPostPlanTableRow;
}(Component);

_defineProperty(SubscribedPostPlanTableRow, "defaultProps", {
  editable: false,
  savingBudget: false
});

export { SubscribedPostPlanTableRow as default };